import PaypalInfo from './paypal-info';

export default PaypalInfo;
